import { render } from "./TrendingChart.vue?vue&type=template&id=d3d6ca7c&ts=true"
import script from "./TrendingChart.vue?vue&type=script&lang=ts"
export * from "./TrendingChart.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__